import usePolledQuery from "apollo/usePolledQuery";
import { PollingIntervalGroups } from "apollo/constants";

import { GET_DEPLOYMENT_FREQUENCY_RANGE } from "./gql";

type UseGetDeploymentFrequencyRangeProps = {
  startTimeUnix: number;
  endTimeUnix: number;
};

const useGetDeploymentFrequencyRange = ({
  startTimeUnix,
  endTimeUnix,
}: UseGetDeploymentFrequencyRangeProps) => {
  const { data, loading, error, refetch, networkStatus, previousData } = usePolledQuery(
    GET_DEPLOYMENT_FREQUENCY_RANGE,
    {
      variables: { input: { startTime: startTimeUnix, endTime: endTimeUnix } },
      pollingGroup: PollingIntervalGroups.Dashboard,
    }
  );

  // Returns raw backend DataPoints (timestamp unix and value as count)
  const range =
    data?.metricsRange?.numberOfDeploymentsRange ??
    previousData?.metricsRange?.numberOfDeploymentsRange;

  return {
    range,
    hasRuns: !!data?.metricsRange?.hasRuns,
    loading,
    error,
    refetch,
    networkStatus,
  };
};

export default useGetDeploymentFrequencyRange;
